// extracted by mini-css-extract-plugin
module.exports = {"botton":"DeleteAgentPoolButton__botton--Pp","confirm":"DeleteAgentPoolButton__confirm--Te"};